import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PageBanner from '../components/PageBanner';
import Footer from '../components/Footer';

export class CustomerSupport extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        <PageBanner title='Customer Support' background='page-banner.jpg' />
        <div className='p-5'>
          <div className='row'>
            <div className='col-md-4 mb-4'>
              <div
                className='p-4 text-center'
                style={{
                  background: '#f8f9fa',
                  borderRadius: '10px',
                  height: '100%',
                }}
              >
                <i
                  className='fa fa-phone'
                  style={{ fontSize: '40px', color: '#2563eb' }}
                ></i>
                <h5 className='mt-3'>Call Us</h5>
                <p>Speak directly with our support team</p>
                <a
                  href='tel:909-407-4131'
                  style={{ color: '#2563eb', fontWeight: 'bold' }}
                >
                  909-407-4131
                </a>
              </div>
            </div>
            <div className='col-md-4 mb-4'>
              <div
                className='p-4 text-center'
                style={{
                  background: '#f8f9fa',
                  borderRadius: '10px',
                  height: '100%',
                }}
              >
                <i
                  className='fa fa-envelope'
                  style={{ fontSize: '40px', color: '#2563eb' }}
                ></i>
                <h5 className='mt-3'>Email Us</h5>
                <p>Get a response within 24 hours</p>
                <a
                  href='mailto:info@itfixed247.com'
                  style={{ color: '#2563eb', fontWeight: 'bold' }}
                >
                  info@itfixed247.com
                </a>
              </div>
            </div>
            <div className='col-md-4 mb-4'>
              <div
                className='p-4 text-center'
                style={{
                  background: '#f8f9fa',
                  borderRadius: '10px',
                  height: '100%',
                }}
              >
                <i
                  className='fa fa-map-marker'
                  style={{ fontSize: '40px', color: '#2563eb' }}
                ></i>
                <h5 className='mt-3'>Visit Us</h5>
                <p>17153 Bear Valley Rd, Hesperia, CA</p>
                <Link
                  to='/contact-us'
                  style={{ color: '#2563eb', fontWeight: 'bold' }}
                >
                  Get Directions
                </Link>
              </div>
            </div>
          </div>

          <div className='mt-5'>
            <h4 className='mb-3'>Frequently Asked Questions</h4>
            <div className='mb-3'>
              <h6>How do I track my order?</h6>
              <p>
                Visit our <Link to='/track-order'>Track Your Order</Link> page
                and enter your order number and email to get real-time updates.
              </p>
            </div>
            <div className='mb-3'>
              <h6>What is your return policy?</h6>
              <p>
                We accept returns within 30 days of purchase. Visit our{' '}
                <Link to='/return-order'>Return Your Order</Link> page to start
                a return.
              </p>
            </div>
            <div className='mb-3'>
              <h6>How can I book a support appointment?</h6>
              <p>
                Head to our{' '}
                <Link to='/book-appointment'>Book An Appointment</Link> page to
                schedule a time that works for you.
              </p>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default CustomerSupport;
